<template>
    <div>
      <div class="panel-header">
        <span class="panel-bar"></span>
        <span class="panel-title">隐私政策</span>
      </div>
  
    
    </div>
  </template>
  
  <script setup>
defineProps({
  profile: {
    type: Object,
    default: () => ({
      nickname: '',
      email: '',
      phone: '',
    }),
  },
})

defineEmits(['edit', 'update-profile'])
  </script>
  
  <style scoped>
  .panel-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 22px;
  }
  
  .panel-bar {
    width: 3px;
    height: 16px;
    border-radius: 2px;
    background: #4caf50;
  }
  
  .panel-title {
    font-size: 14px;
    font-weight: 700;
    color: #2b2f33;
  }
  
  .form {
    padding-left: 22px;
  }
  
  .row {
    display: flex;
    align-items: center;
    min-height: 44px;
    margin: 10px 0;
  }
  
  .label {
    width: 72px;
    color: #2b2f33;
    font-size: 12px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  
  .req {
    color: #e74c3c;
    font-weight: 700;
    transform: translateY(-1px);
  }
  
  .value {
    display: inline-flex;
    align-items: center;
    gap: 14px;
  }
  
  .text {
    font-size: 12px;
    color: #2b2f33;
  }
  
  .link {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font-size: 12px;
    color: #4caf50;
    font-weight: 600;
  }
  
  .link:hover {
    text-decoration: underline;
  }
  </style>